// extracted by mini-css-extract-plugin
export var addressFields = "_ly-0";
export var animationContainer = "_ly-1";
export var footer = "_ly-2";
export var lineItems = "_ly-3";
export var modalContent = "_ly-4";
export var orderName = "_ly-5";
export var strong = "_ly-6";
export var warning = "_ly-7";